module.exports = __webpack_public_path__ + "static/media/backpack.f51518eb.svg";